import React from "react";

import { connect } from "react-redux";
import { getFacilityemrList } from "../../services/employee/action";
import Pagination  from '../common/pagination';
class FacilityEmrList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
    
          
          facilityEmrList:[],
          pageOfItems:[],
        };
      }

      onChangePage = (pageOfItems) => {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
    }

      componentDidMount() {
        let token = this.props.loginDetails;

        
        this.props.getFacilityemrList(token);
    }

    componentWillReceiveProps= nextProps=> {
     if(nextProps.facilitySettingStatus){
         if(nextProps.facilitySettingDetails.facilityEmrSettingList.length>0){
            let facilityEmrList = nextProps.facilitySettingDetails.facilityEmrSettingList;
            this.setState({
                facilityEmrList
            })
         }else{
            this.setState({
                facilityEmrList:[]
            }) 
         }
    
   
     }
    }
   render(){
   
       const {
        //facilityEmrList,
       }=this.state;
      

       return(
           <>
          <div className="content">
                    <div className="contentSection" id="content">
                        <div className="container-fluid">

                            <div className="bodyContent">

                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                                        <div className="titleBg">
                                            <h4> Practice Details </h4>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table commonTable">
                                                <thead>
                                                    <tr>
                                                        <th>Practice</th>
                                                        <th>Connection Type</th>
                                                        <th>VPN Username</th>
                                                        <th>VPN Password</th>
                                                        <th>VPN IP Address</th>
                                                        <th>EMR Username</th>
                                                        <th>EMR Password</th>
                                                        <th>EMR URL</th>
                                                       
                                                     </tr>
                                                </thead>
                                                
                                                <tbody>
                                                   
                                                    {this.state.pageOfItems.length > 0 ?
                                                        this.state.pageOfItems.map((fac, id) => {
                                                            return (
                                                                <tr key={id}>
                                                                    
                                                                    <>

                                                                   <td>{fac.facilityInfoDto.facilityName}</td>
                                                                   <td>{fac.type}</td>
                                                                   <td>{fac.vpnName ? fac.vpnName : "-"}</td>
                                                                   <td>{fac.vpnPassword ? fac.vpnPassword : "-"}</td>
                                                                   <td><span>{fac.ipAddress ? fac.ipAddress : "-"}</span></td>
                                                                   <td>{fac.emrUserName ? fac.emrUserName : "-"}</td>
                                                                   <td>{fac.emrPassword ? fac.emrPassword : "-"}</td>
                                                                   <td><span>{fac.url ? fac.url : "-"}</span></td>
                                                                   </>
                                                               
                                                                 
                                                                    
                                                                </tr>
                                                            )
                                                        }) :<tr style={{background:"transparent"}}><td colspan="6"><img src="images/no-record-found.png" width="180px" alt="" style={{opacity:"0.6"}}/></td></tr>

                                                    }


                                                </tbody>
                                            </table>
                                        </div>
                                    
   <Pagination items={this.state.facilityEmrList}   onChangePage={this.onChangePage} />

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
           </>
       )
   }

}

const mapStateToProps = state => ({
  
    loginDetails: state.commonReducer.loginDetails,
    facilitySettingStatus: state.employeeReducer.facilitySettingStatus,
    facilitySettingDetails:state.employeeReducer.facilitySettingDetails,
   
});

const mapDispatchToProps = dispatch => ({
    getFacilityemrList: token => dispatch(getFacilityemrList(token)),
    
});

 export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FacilityEmrList); 